import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { WindowService } from 'src/shared/providers/window.service';

import { Util } from 'src/shared/util/util';
import { MaintenanceSuggestionsService, MaintenanceSuggestion } from 'src/shared/services/maintenance-suggestions.service';
import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';

@Component({
  selector: 'app-suggestion',
  templateUrl: 'suggestion.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['suggestion.scss', '../tasks.scss'],
  standalone: false
})
export class SuggestionPage implements OnInit {

  dialogParams: any;
  errorMessage: string;
  loaded: boolean;
  suggestion: MaintenanceSuggestion;

  urgencyOptions = [
    {viewValue: 'Low', value: 'low', icon: 'assets/img/low_priority.svg'},
    {viewValue: 'Normal', value: 'normal', icon: 'assets/img/normal_priority.svg'},
    {viewValue: 'High', value: 'high', icon: 'assets/img/high_priority.svg'},
    {viewValue: 'Emergency', value: 'emergency', icon: 'assets/img/emergency_priority.svg'}
  ];

  constructor(
    private navCtrl: CustomNavController,
    private rightSidePanelService: RightSidePanelService,
    private storage: TidyStorage,
    public windowService: WindowService,
    public util: Util,
    private maintenanceSuggestionsService: MaintenanceSuggestionsService,
    private onboardingProvider: OnboardingProvider
  ) {}

  async ngOnInit() {
    this.loadData();
  }

  async loadData() {
    try {
      this.loaded = false;
      this.dialogParams = await this.storage.retrieve('dialog-params');
      this.suggestion = this.dialogParams?.suggestion;
      this.rightSidePanelService.setDialogPageTitle('Suggested Maintenance');
      this.loaded = true;
    } catch (error) {
      this.errorMessage = (error.error && error.error.message) ? error.error.message : error.message;
    }
  }

  getUrgencyIcon(): string {
    const urgency = this.suggestion?.urgency || 'normal';
    const option = this.urgencyOptions.find(o => o.value === urgency);
    return option?.icon || 'assets/img/normal_priority.svg';
  }

  getUrgencyLabel(): string {
    const urgency = this.suggestion?.urgency || 'normal';
    const option = this.urgencyOptions.find(o => o.value === urgency);
    return option?.viewValue || 'Normal';
  }

  async acceptOneTime() {
    await this.acceptSuggestion('one_time');
  }

  async acceptRecurring() {
    await this.acceptSuggestion('recurring');
  }

  async acceptSuggestion(acceptAs: 'recurring' | 'one_time') {
    try {
      await this.maintenanceSuggestionsService.acceptSuggestion(this.suggestion.id, acceptAs);
      this.storage.delete('tasksLastSavedAt');
      if (acceptAs === 'recurring') {
        await this.onboardingProvider.markGoalAsCompleted('addRecurringMaintenance');
        this.onboardingProvider.setShowOnboardingInHeader(true);
      }
      this.closePage();
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

  async rejectSuggestion() {
    try {
      await this.maintenanceSuggestionsService.rejectSuggestion(this.suggestion.id);
      this.storage.delete('tasksLastSavedAt');
      this.closePage();
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

  openPhoto(photoUrl: string) {
    this.util.openUrl(photoUrl);
  }

  closePage() {
    if (this.windowService.isDesktopRes) {
      this.rightSidePanelService.closeRightSidePanel();
    } else {
      this.navCtrl.back();
    }
  }
}
